import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { operations } from './reducers/operations';
import { station } from './reducers/station';
import { tab } from './reducers/tab';
import {modeType } from './reducers/modeType';
import { theme } from './reducers/theme';
import { user } from './reducers/user';
import { partValidation } from './reducers/partValidation';
import { receivePart } from './reducers/receivePart';
import { scanAttribute } from './reducers/scanAttribute';
import { table } from './reducers/tableFilter';
import { GroupLeaderLogin } from './reducers/GroupLeaderLogin';

export const store = configureStore({
	reducer: {
		user: user,
		partValidation: partValidation,
		theme: theme,
		tab: tab,
		station: station,
		operations: operations,
		receivePart: receivePart,
		attribute: scanAttribute,
		table:table,
		modeType: modeType,
		GroupLeaderLogin:GroupLeaderLogin
	},
	middleware: [thunk],
});
